import React from "react"

import { Input } from "../../../../components/shared/Inputs"

const ColorInput = ({ label, value, onChange, className = "" }) => (
  <div className={`space-y-1 ${className}`}>
    <label className="block text-sm font-medium text-gray-700">{label}</label>
    <div className="flex gap-2">
      <input
        type="color"
        value={value || "#000000"}
        onChange={(e) => onChange(e.target.value)}
        className="h-8 w-12 cursor-pointer rounded border border-gray-light"
      />
      <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="#000000" className="flex-1" />
    </div>
  </div>
)

export default ColorInput
